import React, { FC, ReactElement } from 'react';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../config/routes';
import { useSelector } from 'react-redux';
import { getContentDataIntro, getIsLoggedIn, getIsRegistrationRequired, getExhibitionMainPage, getSponsorPages } from '../../../stores/reducers/userData';
import './exhibition.sass';
import localeFieldResolver from '../../../helpers/locale-field-finder';
import { internalizationState } from '../../../stores/reducers/sections';
interface ExhibitionContent {
  title: string
  description: string
  note: string
  path: string
}

const ExhibitionPage: FC = (): ReactElement => {
  const history = useHistory();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isRegistrationRequired = useSelector(getIsRegistrationRequired);
  const shouldRegister = !isLoggedIn && isRegistrationRequired;
  if (shouldRegister) history.push(routes.REGISTER);

  const exhibitionMainPageData = useSelector(getExhibitionMainPage);
  const sponsorPages = useSelector(getSponsorPages);
  const { backendURL } = useSelector(getContentDataIntro);
  const { activeLangState } = useSelector(internalizationState);

  const getRoute = (pageType: string = '', pageId: string): string => {
    // const pageTypes = ['custom.theme.list', 'custom.theme', 'double.header.list', 'partner', 'partners.list', 'sp']
    switch (pageType) {
      case 'custom.theme.list':
        return routes.DEMOZONE;
      case 'custom.theme':
        return `${routes.DEMOZONE_INFO}?code=${pageId}`;
      case 'double.header.list':
        return routes.EXHIBITION;
      case 'partners.list':
        return routes.EXHIBITION_OF_SPONSORS;
      case 'partner':
        const partner = sponsorPages.find((item: any): any => item.id === pageId);
        return `${routes.SPONSOR_PAGE}?name=${partner.title.toLowerCase()}`;
      case 'sp':
        return `${routes.STATIC}/${pageId}`;
      default:
        return '/'
    }
  };

  return (
    <section
      className="exhibition"
      style={{
        backgroundImage: `url(${backendURL}${exhibitionMainPageData.image})`
      }}
    >
      <div className="exhibition__item">
        <div className="exhibition__item__wrapper flex flex-column justify-between">
          <div className="exhibition__content flex flex-column items-start">
            <h1>{ localeFieldResolver(exhibitionMainPageData, 'titleBlock1', activeLangState) }</h1>
            <p className="exhibition__description">{ localeFieldResolver(exhibitionMainPageData, 'subtitleBlock1', activeLangState) }</p>
            <Link className="btn btn-primary btn--mobile-min bg-footer" to={getRoute(exhibitionMainPageData.pageTypeBlock1, exhibitionMainPageData.pageBlock1)}>
              { localeFieldResolver(exhibitionMainPageData, 'buttonBlock1', activeLangState) }
            </Link>
          </div>
          <div className="exhibition__note">
            <p><i>{ localeFieldResolver(exhibitionMainPageData, 'textBlock1', activeLangState) }</i></p>
          </div>
        </div>
      </div>

      <div className="exhibition__item">
        <div className="exhibition__item__wrapper flex flex-column justify-between">
          <div className="exhibition__content flex flex-column items-start">
            <h1>{ localeFieldResolver(exhibitionMainPageData, 'titleBlock2', activeLangState) }</h1>
            <p className="exhibition__description">{ localeFieldResolver(exhibitionMainPageData, 'subtitleBlock2', activeLangState) }</p>
            <Link className="btn btn-primary btn--mobile-min bg-footer" to={getRoute(exhibitionMainPageData.pageTypeBlock2, exhibitionMainPageData.pageBlock2)}>
              { localeFieldResolver(exhibitionMainPageData, 'buttonBlock2', activeLangState) }
            </Link>
          </div>
          <div className="exhibition__note">
            <p><i>{ localeFieldResolver(exhibitionMainPageData, 'textBlock2', activeLangState) }</i></p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ExhibitionPage;
